import React from "react";
import {
  CreateCompany,
  CreateCustomerPartDialog,
  CreateLaborDialog,
  CreatePurchaseOrder,
  ShipmentDetailsDialog,
} from "../../dialogs";

export const CreateWrapper = ({ children }) => {
  return (
    <>
      {children}
      <CreateCustomerPartDialog />
      <CreateCompany />
      <CreatePurchaseOrder />
      <CreateLaborDialog />
      <ShipmentDetailsDialog />
    </>
  );
};

export default CreateWrapper;
